import { CommonEventProperties } from '../../utils/CommonParams';
import { EventSchema } from '../../interfaces/EventInterfaces';
import { EVENT_NAME as EN } from '../../constants/EventName';
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey';

const commonProperties = CommonEventProperties;

export const PromotionCollectionEventSchema = (isClicked: boolean): EventSchema => {
    return {
        eventName: isClicked ? EN.PROMOTION_COLLECTION_CLICKED : EN.PROMOTION_COLLECTION_VIEWED,
        params: {
            ...commonProperties,
            BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
            EVENT_CATEGORY: EPK.EVENT_CATEGORY,
            PROMOTION_COLLECTION_NAME: EPK.PROMOTION_COLLECTION_NAME,
            PROMOTION_COLLECTION_POSITION: EPK.PROMOTION_COLLECTION_POSITION,
            STORE_ID_DBP: EPK.STORE_ID_DBP,
            STORE_ID_SAP: EPK.STORE_ID_SAP,
            STORE: EPK.STORE
        }
    }
}